import { headerLoginWindow } from '@pc/components/HeaderLoginWindow'
import { clickEvent, clickUxCv } from '@pc/components/EventTrack'
import { smoothScrollHandler } from '@pc/components/SmoothScrollHandler'
import { initPageTop } from '@pc/components/PageTop'
import { disableDoubleSubmit } from '@pc/components/DisableDoubleSubmit'

document.addEventListener('DOMContentLoaded', () => {
  // ヘッダーのログイン情報入力ウィンドウ
  headerLoginWindow()

  // クリックイベント計測用
  clickEvent()

  // UX CV のクリックイベント計測用
  clickUxCv()

  // スムーズスクロール
  smoothScrollHandler()

  // 「ページトップへ」ボタン
  initPageTop()

  // 二重submit防止
  disableDoubleSubmit()
})
